import { render, staticRenderFns } from "./giftsPop.vue?vue&type=template&id=dca99228&scoped=true&"
import script from "./giftsPop.vue?vue&type=script&lang=ts&"
export * from "./giftsPop.vue?vue&type=script&lang=ts&"
import style0 from "./giftsPop.vue?vue&type=style&index=0&id=dca99228&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca99228",
  null
  
)

export default component.exports